export default __webpack_public_path__ + "static/media/logo.8dd3cd49.png";